import { action, payload } from 'ts-action';
import { Quiz } from '../../@types/quiz.interfaces';

export interface ICreateQuizPayload {
    name: 'CREATE_QUIZ';
    data: {
        user_id: number;
        course_id: number;
        quiz_duration: number;
    };
}

export interface IFetchQuizPayload {
    name: 'QUIZ';
    data: {
        id: number;
    };
}

export interface IFetchQuizzesPayload {
    name: 'QUIZZES';
}

export interface IUpdateQuizPayload {
    name: 'UPDATE_QUIZ';
    data: {
        quiz_id: number;
        user_id: number;
        course_id: number;
        quiz_duration: number;
    };
}

export interface IDeleteQuizPayload {
    name: 'DELETE_QUIZ';
    data: {
        id: number;
    };
}

export const QUIZ = 'QUIZ';
export const QUIZZES = 'QUIZZES';
export const CLEAR_QUIZ = 'CLEAR_QUIZ';
export const CLEAR_QUIZZES = 'CLEAR_QUIZZES';

export const fetchQuiz = action(QUIZ, payload<{ quiz: Quiz }>());
export const fetchQuizzes = action(QUIZZES, payload<{ quizzes: Quiz[] }>());
export const clearQuiz = action(CLEAR_QUIZ);
export const clearQuizzes = action(CLEAR_QUIZZES);

export type QuizActionType =
    | ReturnType<typeof fetchQuiz>
    | ReturnType<typeof fetchQuizzes>
    | ReturnType<typeof clearQuiz>
    | ReturnType<typeof clearQuizzes>;

const QuizActionAPI = {
    clearQuiz,
    clearQuizzes,
};

export default QuizActionAPI;
